import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { PhBhpManageinstitutionComponent } from './ph-bhp-manageinstitution/ph-bhp-manageinstitution.component';
import { PhBhpAddinstitutionComponent } from './ph-bhp-addinstitution/ph-bhp-addinstitution.component';

import { PhBhpViewinstitutionComponent } from './ph-bhp-viewinstitution/ph-bhp-viewinstitution.component';
import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhBhpTrialinstitutionComponent } from './ph-bhp-trialinstitution/ph-bhp-trialinstitution.component';
import { NgxMaskModule} from 'ngx-mask';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { CommonModule, DatePipe } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import { ViewLayoutComponent } from './ph-bhp-viewinstitution/view-layout/view-layout.component';
import { OverviewDetailComponent } from './ph-bhp-viewinstitution/overview-detail/overview-detail.component';
import { UserDetailsComponent } from './ph-bhp-viewinstitution/user-details/user-details.component';
import { WebkessSettingsComponent } from './ph-bhp-webKess/webkess-settings/webkess-settings.component';
import { ExportToWebKessComponent } from './ph-bhp-webKess/export-to-web-kess/export-to-web-kess.component';
import { WebkessReportComponent } from './ph-bhp-webKess/webkess-report/webkess-report.component';
import { WebkessLayoutComponent } from './ph-bhp-webKess/webkess-layout/webkess-layout.component';
import { SOPSelectionByTypeComponent } from './sop-selection-by-type/sop-selection-by-type.component';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatListModule } from '@angular/material/list';
// common libraries

import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BrowserModule } from '@angular/platform-browser';
import { PhBhpUiModule } from "../../../ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ClientLibModule } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';
import { PhBhpFeatureComponentsModule } from 'ph-bhp-feature-packages/ph-bhp-feature-components/public_api';


registerLocaleData(localeFr);
registerLocaleData(localeEn);
registerLocaleData(localeDe);


@NgModule({
    declarations: [
        PhBhpManageinstitutionComponent,
        PhBhpAddinstitutionComponent,
        PhBhpTrialinstitutionComponent,
        PhBhpViewinstitutionComponent,
        ViewLayoutComponent,
        OverviewDetailComponent,
        UserDetailsComponent,
        WebkessLayoutComponent,
        WebkessSettingsComponent,
        ExportToWebKessComponent,
        WebkessReportComponent,
        SOPSelectionByTypeComponent
    ],
    providers: [
        DatePipe
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    imports: [
        MatInputModule,
        CommonModule,
        BrowserModule,
        PHBHPLayoutPackageModule,
        PHBHPLocalizePackageModule,
        FormsModule,
        ExcelExportModule,
        ReactiveFormsModule,
        NgxMaskModule.forRoot(),
        TabsModule.forRoot(),
        BsDatepickerModule.forRoot(),
        PhBhpUiModule,
        MatFormFieldModule,
        MatSlideToggleModule,
        MatIconModule,
        MatSelectModule,
        MatRadioModule,
        MatListModule,
        MatDatepickerModule, 
        MatNativeDateModule,
        ClientLibModule,
        PhBhpFeatureComponentsModule
    ]
})
export class PHBHPFeaturePackageInsitutionManagementModule { }
